var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-base-family',{ref:"baseEdit",attrs:{"title":"Adresse","width":"900"}},[_c('address-edit',{attrs:{"address":_vm.family.address}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }